import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';
export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  created() {
    this.$store.dispatch('productRegistrationGroup/getItems');
    this.$store.dispatch('productCategory/getItems');
    this.$store.dispatch('product/getItems');
    this.$store.dispatch('productAttributeItem/getItems');
    this.$store.dispatch('depositClass/getItems');
    this.$store.dispatch('productAttribute/getItems');
  },
  mixins: [baseCrudMixin],
  data: () => ({
    entity: 'Product',
    returnTo: 'Products'
  }),
  methods: {
    getDependencies(data) {
      return [];
    },
    createDefinition() {
      return getFormDefinition(this);
    },
    createFormDataFromItem,
    createItemFromFormData
  }
};
